import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=c0ffed5c&scoped=true"
import script from "./LoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoginSuccess.vue?vue&type=script&lang=js"
import style0 from "./LoginSuccess.vue?vue&type=style&index=0&id=c0ffed5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ffed5c",
  null
  
)

export default component.exports